export const FETCH_PROFESSION_REQUEST = "FETCH_PROFESSION_REQUEST";
